module.exports = __webpack_public_path__ + "static/img/14-14.ccf19e7f.jpeg";